import { render, staticRenderFns } from "./ConfirmBuyDialog.vue?vue&type=template&id=54d48cb1&scoped=true"
import script from "./ConfirmBuyDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmBuyDialog.vue?vue&type=script&lang=js"
import style0 from "./ConfirmBuyDialog.vue?vue&type=style&index=0&id=54d48cb1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d48cb1",
  null
  
)

export default component.exports